export default __webpack_public_path__ + "5a913cf8bbb681a7a93741d5dcaa3837.png";